import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/y-combinator': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 32v448h-448v-448h448zM236 287.5l77.5-145.5h-32.7l-45.8 91c-4.7 9.3-9 18.3-12.8 26.8l-12.2-26.8-45.2-91h-35l76.7 143.8v94.5h29.5v-92.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/y-combinator.js
// module id = 1105
// module chunks = 0